export enum RfcDialogFormFields {
  PROS = 'pros',
  MADCODE = 'madCode',
  NAME = 'name',
  ADDRESS = 'address',
  RFC_NUMBER = 'rfcNbr'
}
